export const gridGlobals = {
  display: "grid",
  gridGap: [4, 4, 6, 6],
}
